import { ReactNode } from "react"
import styled from "styled-components"

interface ChartEmptyStateProps {
  skeleton?: ReactNode
  message?: string
  minHeight?: number
  messageFontSize?: number
  className?: string
}

const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  width: 100%;
`

const Message = styled.div<{ $fontSize: number }>`
  color: var(--text-primary);
  text-align: center;
  font-family: "Inter", sans-serif;
  font-size: ${({ $fontSize }) => `${$fontSize}px`};
  font-style: normal;
  font-weight: 500;
  line-height: 1.4;
  letter-spacing: -0.22px;
`

export const ChartEmptyState = ({
  skeleton,
  message = "No data to display",
  messageFontSize = 20,
  className,
}: ChartEmptyStateProps) => (
  <Container className={className}>
    {skeleton}
    <Message $fontSize={messageFontSize}>{message}</Message>
  </Container>
)
